import React from 'react';
import _ from 'lodash';
import styles from './css/MediaBarItem.styl';
import {
  bindMethods,
  setRef,
} from '../../../../shared/utilities/componentHelpers';
import {MEDIA_TYPES} from '../../../../shared/utilities/constants';
import {VideoUploadIcon} from '../../../../shared/Svgs';

export default class MediaBarItem extends React.Component {
  static propTypes = {
    caption: React.PropTypes.string,
    handleEditOverlay: React.PropTypes.func,
    mediaType: React.PropTypes.string,
    filename: React.PropTypes.string,
    parentRefGetter: React.PropTypes.func.isRequired,
    url: React.PropTypes.string,
  };

  /**
   * MediaBarItem Component constructor
   * @param  {object}    props passed in properties
   * @return {Undefined} Returns nothing
   */
  constructor(props) {
    super(props);

    this.state = {
      captionStyles: {},
      arrowStyles: {},
    };

    this.mediaBarItemRef = null;
    this.setMediaBarItemRef = _.partial(setRef, _, 'mediaBarItemRef', this);
    this.fileName = this.formatFileName(props.filename);

    bindMethods(this, ['setStyles']);
  }

  formatFileName(filename) {
    let name = _.isString(filename) ? filename : '';

    if (name.length > 36) {
      const beginning = name.substr(0, name.lastIndexOf('.') - 3);
      const end = name.substr(beginning.length - 1, name.length);
      const options = {length: 30 - end.length};

      name = `${_.truncate(beginning, options)}${end}`;
    }

    return name;
  }

  /**
   * Sets styles for captions
   * @return {Undefined} Returns nothing
   */
  setStyles() {
    const parentElement = this.props.parentRefGetter();
    const element = this.mediaBarItemRef;

    if (parentElement && element) {
      const parentRect = parentElement.getBoundingClientRect();
      const selfRect = element.getBoundingClientRect();
      const captionWidth = 300;
      const arrowWidthOffset = 15;
      const captionOffset = 10;
      let captionLeft = -((captionWidth - selfRect.width) / 2);
      let arrowLeft = captionWidth / 2;
      const xMin = selfRect.left - parentRect.left + captionLeft;
      const xMax =
        selfRect.left + selfRect.width - parentRect.width - captionLeft;

      if (xMin < 0) {
        captionLeft -= captionLeft - captionOffset;
        arrowLeft = selfRect.width / 2 - captionOffset;
      } else if (xMax > 0) {
        const diff =
          parentRect.width + parentRect.left - (selfRect.left + selfRect.width);

        captionLeft += captionLeft + diff - captionOffset;
        arrowLeft = captionWidth - selfRect.width / 2 - diff + captionOffset;
      }

      this.setState({
        captionStyles: {
          display: 'block',
          left: `${captionLeft}px`,
          top: `${selfRect.height - 10}px`,
        },
        arrowStyles: {
          left: `${arrowLeft - arrowWidthOffset}px`,
        },
      });
    }
  }

  /**
   * React Component render.
   * @return {JSX} MediaBarItem rendered.
   */
  render() {
    const {caption, handleEditOverlay, mediaType, url} = this.props;

    return url ? (
      <div
        className={styles.MediaBarItem}
        onClick={handleEditOverlay}
        onMouseOver={caption ? this.setStyles : null}
        ref={this.setMediaBarItemRef}
      >
        {caption ? (
          <aside style={this.state.captionStyles}>
            <div className={styles.arrow} style={this.state.arrowStyles} />
            <p>{caption}</p>
          </aside>
        ) : null}
        {mediaType === MEDIA_TYPES.video ? (
          <div className={styles.mediaDisplay}>
            <VideoUploadIcon />
            <p>{this.fileName}</p>
          </div>
        ) : (
          <img src={url} />
        )}
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/GuestBook/MediaBarItem.js